import { createContext } from "react";

import type { SyntheticEvent } from "react";

export type AccordionVariant = "plain" | "contained";

export interface AccordionGroupContextValue {
  variant: AccordionVariant;
  isExpanded: (value: string) => boolean;
  toggle: (event: SyntheticEvent, value: string, isExpanded: boolean) => void;
}

/**
 * Lets an `Accordion` find the `AccordionGroup` it sits in, however deeply a
 * consumer wraps it. Lives beside `Accordion` rather than `AccordionGroup` so
 * the two folders import in one direction only.
 */
export const AccordionGroupContext =
  createContext<AccordionGroupContextValue | null>(null);
